module.exports = __webpack_public_path__ + "img/tha_chamber_logo.2a0ed4d5.png";